import React from 'react';
import { useOrg } from '../contexts/OrgContext';
import AdminBilling from './AdminBilling';
import Statements from './Statements';

/**
 * Une page « Facturation », deux lectures selon l'organisation de travail.
 *
 * - Admin sans organisation choisie (« Admin » dans l'appbar) : le pilotage de
 *   toutes les organisations (émission, notes de crédit, factures Odoo).
 * - Admin qui a choisi une organisation : exactement ce que voit cet
 *   organisateur. L'en-tête `X-Organization-Id` fait répondre
 *   `/organizations/me/statements` pour elle, rien à ajouter côté serveur.
 * - Organisateur : ses relevés, comme avant.
 *
 * `key` remonte l'écran à chaque changement d'organisation : sinon il
 * garderait les relevés de la précédente.
 */
const Billing: React.FC = () => {
  const { isAdmin, workingOrgId } = useOrg();
  if (isAdmin && !workingOrgId) return <AdminBilling />;
  return <Statements key={workingOrgId || 'self'} />;
};

export default Billing;
